/* Sika 3D generator: request drawer (21 Oct 2026, Dee's flow).
   - The Hulk form (assets/cpg-request.js) asks "Add more models to this request?" (required, Yes / No).
     No  -> the form sends as before; nothing here ever shows.
     Yes -> the form is not sent. Its details come here ({type:'sika-cfgreq-add', fields}), the model is added as the first
            line, the drawer opens on the left, and "Request this configuration" reads "Add to request" from then on.
   - The drawer: one line per configuration (preview, materials, quantity, Edit, Remove), the saved details in the same
     Hulk form in "final" mode, and Send request at the bottom: one email with every line, the total and one link that
     shows the whole request (?req=...).
   - Stored in this browser for 30 days: localStorage 'cpg_req_v1' = { t, fields, lines:[{id,h,title,cfg,qty,frame,img,rows,link}] }.
   Roll back: remove the cpg-request-list script/style tags from sections/custom-product-generator.liquid. */
(function () {
  'use strict';
  if (window.__cpgReqList) return; window.__cpgReqList = 1;
  if (/[?&]cpg_dress=/.test(location.search) || window.CPG_ENGINE_ONLY) return;
  var KEY = 'cpg_req_v1', DAYS30 = 30 * 864e5, HULK = 'https://formbuilder.hulkapps.com';
  var DESK = window.matchMedia('(min-width: 1200px), (min-width: 768px) and (orientation: landscape)');
  var Q = new URLSearchParams(location.search);
  var PLANNER_URL = '/pages/floor-planner';   /* the Floor planner page; "Add everything to floorplan" builds a plan and opens it */
  var PLAN_KEY = 'cpg_plan_v1';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function enc(o) { return btoa(unescape(encodeURIComponent(JSON.stringify(o)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function dec(s) { var b = String(s).replace(/-/g, '+').replace(/_/g, '/'); while (b.length % 4) b += '='; return JSON.parse(decodeURIComponent(escape(atob(b)))); }
  function slug(s) { return String(s || '').toLowerCase().replace(/\s*\|\s*/g, '-').replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function uid() { return 'r' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }

  /* ---------- storage ---------- */
  var req = (function () {
    var r = null; try { r = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (!r || !r.lines || !(Date.now() - (r.t || 0) < DAYS30)) r = { t: Date.now(), fields: null, lines: [] };
    return r;
  })();
  function save() { req.t = Date.now(); try { localStorage.setItem(KEY, JSON.stringify(req)); } catch (e) {} }
  function active() { return req.lines.length > 0; }
  function total() { return req.lines.reduce(function (a, l) { return a + (+l.qty || 0); }, 0); }
  function sameCfg(a, b) { return JSON.stringify(a) === JSON.stringify(b); }

  /* ---------- the current configuration ---------- */
  function current() {
    var g = window.cpgPlannerData ? window.cpgPlannerData() : null, s = window.cpgReqState ? window.cpgReqState() : null;
    if (!g || !s) return null;
    return { h: g.current, title: s.title || g.title, cfg: g.state, frame: s.frame || '', img: s.img || '', rows: s.rows || [], link: s.link };
  }
  function previewChain(l) {
    return [l.h && l.frame ? '/cdn/shop/files/3d_preview_' + l.h + '_' + slug(l.frame) + '.png?width=480' : '', l.h ? '/cdn/shop/files/3d_standard_' + l.h + '.png?width=480' : '', l.img].filter(Boolean);
  }
  function editLink(l) { return location.pathname + '?product=' + encodeURIComponent(l.h) + '&cfg=' + enc(l.cfg) + '&req_edit=' + encodeURIComponent(l.id); }
  function requestLink() {
    return location.origin + location.pathname + '?req=' + enc({ l: req.lines.map(function (l) { return [l.h, l.cfg, +l.qty || 1]; }) });
  }

  /* ---------- markup ---------- */
  var IC = {
    close: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13"/></svg>',
    list: '<svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M5 4h9M5 8h9M5 12h9"/><circle cx="2" cy="4" r=".8" fill="currentColor"/><circle cx="2" cy="8" r=".8" fill="currentColor"/><circle cx="2" cy="12" r=".8" fill="currentColor"/></svg>',
    up: '<svg width="16" height="16" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 9l4-4 4 4"/></svg>',
    plus: '<svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><rect x="1.5" y="1.5" width="13" height="13"/><path d="M8 5v6M5 8h6"/></svg>',
    check: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3.5 9.5l3.5 3.5 7.5-8"/></svg>'
  };
  var shade = document.createElement('div'); shade.className = 'cpgr-shade'; shade.hidden = true;
  var dr = document.createElement('aside');
  dr.className = 'cpgr'; dr.setAttribute('role', 'dialog'); dr.setAttribute('aria-modal', 'true'); dr.setAttribute('aria-labelledby', 'cpgr-t'); dr.hidden = true;
  dr.innerHTML =
    '<div class="cpgr__head"><div><h2 class="cpgr__title" id="cpgr-t">Your request</h2><p class="cpgr__sum" data-sum></p></div>' +
      '<button type="button" class="cpgr__x" data-close aria-label="Close">' + IC.close + '</button></div>' +
    '<div class="cpgr__scroll">' +
      '<div class="cpgr__lines" data-lines></div>' +
      '<p class="cpgr__more" data-more><button type="button" class="cpgr__morelink" data-addmodel>' + IC.plus + '<span>Add another model</span></button><span class="cpgr__morehint">Choose a model, configure it and choose <strong>Add to request</strong>.</span></p>' +
      '<section class="cpgr__details" data-details><h3 class="cpgr__h">Your details</h3><div class="cpgr__form" data-form></div></section>' +
      '<div class="cpgr__done" data-done hidden></div>' +
    '</div>' +
    '<div class="cpgr__foot" data-foot>' +
      '<button type="button" class="cpgr__btn cpgr__btn--solid" data-send>Send request</button>' +
      '<button type="button" class="cpgr__btn cpgr__btn--icon" data-plan hidden>' + IC.plus + '<span>Add everything to floorplan</span></button>' +
    '</div>';
  document.body.appendChild(shade); document.body.appendChild(dr);
  var $ = function (s) { return dr.querySelector(s); };
  var linesEl = $('[data-lines]'), sumEl = $('[data-sum]'), sendBtn = $('[data-send]'), planBtn = $('[data-plan]');
  if (PLANNER_URL) planBtn.hidden = false;

  /* entry points while a request is going: desktop pill under Download images, phone bar at the bottom */
  var pill = document.createElement('button'); pill.type = 'button'; pill.className = 'cpg-snap__tab cpgr-tab'; pill.hidden = true;
  var bar = document.createElement('button'); bar.type = 'button'; bar.className = 'cpgr-bar'; bar.hidden = true;
  document.body.appendChild(bar);
  var toast = document.createElement('div'); toast.className = 'cpgr-toast'; toast.setAttribute('role', 'status'); toast.hidden = true; document.body.appendChild(toast);
  var toastT = 0;
  function say(t) { toast.textContent = t; toast.hidden = false; clearTimeout(toastT); toastT = setTimeout(function () { toast.hidden = true; }, 3800); }

  /* ---------- drawer open / close ---------- */
  var viewOnly = null;   // a shared request opened from ?req=
  function openDrawer() {
    render(); dr.hidden = false; shade.hidden = false;
    requestAnimationFrame(function () { dr.classList.add('is-open'); shade.classList.add('is-open'); });
    document.documentElement.classList.add('cpgr-lock');
    if (!viewOnly) loadForm();
    setTimeout(function () { var x = $('[data-close]'); try { x.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function closeDrawer() {
    dr.classList.remove('is-open'); shade.classList.remove('is-open');
    document.documentElement.classList.remove('cpgr-lock');
    setTimeout(function () { if (!dr.classList.contains('is-open')) { dr.hidden = true; shade.hidden = true; } }, 300);
  }
  $('[data-close]').addEventListener('click', closeDrawer);
  shade.addEventListener('click', closeDrawer);
  dr.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  pill.addEventListener('click', function (e) { e.stopPropagation(); openDrawer(); });
  bar.addEventListener('click', openDrawer);

  /* ---------- render ---------- */
  function rowsHtml(rows) { return (rows || []).filter(function (r) { return r[1] && r[1] !== 'None'; }).map(function (r) { return '<span><b>' + esc(r[0]) + '</b> ' + esc(r[1]) + '</span>'; }).join(''); }
  function render() {
    var lines = viewOnly || req.lines, n = lines.length, pcs = lines.reduce(function (a, l) { return a + (+l.qty || 0); }, 0);
    sumEl.textContent = n ? n + (n === 1 ? ' model' : ' models') + ' · ' + pcs + (pcs === 1 ? ' piece' : ' pieces') : '';
    $('.cpgr__title').textContent = viewOnly ? 'Shared request' : 'Your request';
    linesEl.innerHTML = lines.map(function (l) {
      return '<div class="cpgr__line" data-id="' + esc(l.id) + '">' +
        '<p class="cpgr__name">' + esc(l.title) + '</p>' +
        '<span class="cpgr__img"><img alt="" data-chain="' + esc(JSON.stringify(previewChain(l))) + '"></span>' +
        '<div class="cpgr__info"><p class="cpgr__rows">' + rowsHtml(l.rows) + '</p>' +
          (viewOnly ? '<p class="cpgr__links"><a href="' + esc(l.link || editLink(l).replace(/&req_edit=[^&]*/, '')) + '">Open in 3D</a></p>'
                    : '<p class="cpgr__links"><a href="' + esc(editLink(l)) + '">Edit</a><button type="button" data-rm>Remove</button></p>') +
        '</div>' +
        (viewOnly ? '<div class="cpgr__qty"><span>' + (+l.qty || 1) + ' pcs</span></div>'
                  : '<div class="cpgr__qty"><button type="button" data-q="-1" aria-label="One less">−</button><label class="cpgr__qn"><span class="cpgr__sr">Quantity</span><input inputmode="numeric" value="' + (+l.qty || 1) + '" data-qv></label><button type="button" data-q="1" aria-label="One more">+</button></div>') +
      '</div>';
    }).join('') || '<p class="cpgr__empty">Your request is empty.</p>';
    linesEl.querySelectorAll('img[data-chain]').forEach(function (img) {
      var chain = JSON.parse(img.getAttribute('data-chain'));
      img.onerror = function () { var nx = chain.shift(); if (nx) img.src = nx; else img.onerror = null; };
      img.src = chain.shift() || '';
    });
    $('[data-more]').hidden = !!viewOnly || !n;
    $('[data-details]').hidden = !!viewOnly || !n;
    $('[data-foot]').hidden = !!viewOnly || !n;
    // entry points
    var on = active() && !viewOnly;
    pill.innerHTML = IC.list + '<span>Your request · ' + req.lines.length + '</span>';
    placePill();
    bar.innerHTML = '<span class="cpgr-bar__txt"><span class="cpgr-bar__t">Your request</span><span class="cpgr-bar__n">' + req.lines.length + (req.lines.length === 1 ? ' model' : ' models') + ' · ' + total() + ' pcs</span></span>' + IC.up;
    bar.hidden = !(on && !DESK.matches);
    document.documentElement.classList.toggle('cpgr-hasbar', on && !DESK.matches);
    pill.hidden = !(on && DESK.matches);
    buttonLabel();
    if (window.__cpgrSyncModDrawer) window.__cpgrSyncModDrawer();
    postFinal();
  }
  function placePill() {
    var dl = document.querySelector('.cpg__grid .cpg-snap__tab:not(.cpg-share__tab):not(.cpgr-tab)'), host = dl && dl.parentElement;
    if (!host) return;
    if (pill.parentElement !== host) host.appendChild(pill);
    pill.style.left = dl.style.left || '0px'; pill.style.paddingLeft = dl.style.paddingLeft || '';
    pill.style.setProperty('top', (dl.offsetTop + dl.offsetHeight + 12) + 'px', 'important'); pill.style.setProperty('bottom', 'auto', 'important');
  }
  (function watchDl() { var dl = document.querySelector('.cpg__grid .cpg-snap__tab:not(.cpg-share__tab):not(.cpgr-tab)');
    if (!dl) { setTimeout(watchDl, 500); return; } placePill(); if (window.MutationObserver) new MutationObserver(placePill).observe(dl, { attributes: true, attributeFilter: ['style', 'class'] }); })();
  (DESK.addEventListener ? DESK.addEventListener('change', render) : DESK.addListener(render));
  window.addEventListener('resize', function () { setTimeout(placePill, 60); });

  linesEl.addEventListener('click', function (e) {
    var row = e.target.closest('[data-id]'); if (!row || viewOnly) return;
    var l = req.lines.filter(function (x) { return x.id === row.getAttribute('data-id'); })[0]; if (!l) return;
    var q = e.target.closest('[data-q]');
    if (q) { l.qty = Math.max(1, Math.min(9999, (+l.qty || 1) + (+q.getAttribute('data-q')))); save(); render(); return; }
    if (e.target.closest('[data-rm]')) { req.lines = req.lines.filter(function (x) { return x !== l; }); save(); render(); if (!active()) closeDrawer(); }
  });
  linesEl.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-qv]'); if (!inp) return;
    var row = inp.closest('[data-id]'), l = req.lines.filter(function (x) { return x.id === row.getAttribute('data-id'); })[0]; if (!l) return;
    l.qty = Math.max(1, Math.min(9999, parseInt(inp.value, 10) || 1)); save(); render();
  });

  /* ---------- the configurator button ---------- */
  var editId = Q.get('req_edit');
  if (editId && !req.lines.some(function (l) { return l.id === editId; })) editId = null;
  function reqBtn() { return document.querySelector('.cpg__request'); }
  function buttonLabel() {
    var b = reqBtn(); if (!b) return;
    var t = b.querySelector('.text-with-icon') || b;
    if (!b.__cpgrOrig) b.__cpgrOrig = t.textContent;
    t.textContent = planEdit ? 'Update in floorplan' : editId ? 'Update in request' : (active() ? 'Add to request' : b.__cpgrOrig);
  }
  function addCurrent(qty, fromForm) {
    var c = current(); if (!c) return null;
    var line = null;
    if (editId) {
      line = req.lines.filter(function (l) { return l.id === editId; })[0];
      if (line) Object.assign(line, c);
      editId = null;
      try { var q = new URLSearchParams(location.search); q.delete('req_edit'); history.replaceState(null, '', location.pathname + (q.toString() ? '?' + q : '') + location.hash); } catch (e) {}
    }
    if (!line) {
      line = req.lines.filter(function (l) { return l.h === c.h && sameCfg(l.cfg, c.cfg); })[0];
      if (line) line.qty = (+line.qty || 0) + (qty || 1);
      else { line = Object.assign({ id: uid(), qty: qty || 1 }, c); req.lines.push(line); }
    }
    save(); render();
    return line;
  }
  /* Edit from the Floor planner (?plan_edit=<key>): the button reads "Update in floorplan", replaces those pieces and goes back */
  var planEdit = Q.get('plan_edit');
  function readPlan() { try { return JSON.parse(localStorage.getItem(PLAN_KEY) || 'null'); } catch (e) { return null; } }
  if (planEdit) { var pl0 = readPlan(); if (!pl0 || !(pl0.items || []).some(function (i) { return i.key === planEdit; })) planEdit = null; }
  function planKey(h, cfg) { return h + '|' + (cfg ? enc(cfg) : 'default'); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.cpg__request');
    if (!b || !planEdit) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var g = window.cpgPlannerData && window.cpgPlannerData(), pl = readPlan(); if (!g || !pl) return;
    var k = planKey(g.current, g.state);
    pl.items.forEach(function (i) { if (i.key === planEdit) { i.key = k; i.h = g.current; i.cfg = g.state; i.title = g.title; } });
    pl.t = Date.now(); try { localStorage.setItem(PLAN_KEY, JSON.stringify(pl)); } catch (er) {}
    location.href = PLANNER_URL + '#cpg-planner';
  }, true);

  // while a request is going, the button adds to it (instead of opening the form)
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.cpg__request');
    if (!b || planEdit || !(active() || editId)) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var l = addCurrent(1);
    if (l) { openDrawer(); flash(l.id); }
  }, true);
  function flash(id) { setTimeout(function () { var r = linesEl.querySelector('[data-id="' + id + '"]'); if (r) { r.classList.add('is-flash'); r.scrollIntoView({ block: 'nearest' }); setTimeout(function () { r.classList.remove('is-flash'); }, 1600); } }, 80); }

  /* ---------- messages from the Hulk forms ---------- */
  var frame = null, frameReady = false;
  window.addEventListener('message', function (e) {
    if (e.origin !== HULK) return;
    var d = e.data; if (typeof d === 'string') { try { d = JSON.parse(d); } catch (x) { return; } }
    if (!d || !d.type) return;
    var mine = frame && e.source === frame.contentWindow;
    if (d.type === 'sika-cfgreq-add' && !mine) {
      // "Yes" in the configurator's form: keep the details, start the request
      req.fields = d.fields || req.fields;
      var qty = Math.max(1, parseInt((d.fields || {})['Desired quantity'], 10) || 1);
      var l = addCurrent(qty, true);
      try { window.cpgReqClose && window.cpgReqClose(); } catch (er) {}
      if (l) { openDrawer(); flash(l.id); }
      return;
    }
    if (!mine) return;
    if (d.type === 'sika-cfgreq-ready') { frameReady = true; postFinal(); return; }
    if (d.type === 'sika-cfgreq-h' && d.h) { frame.style.height = d.h + 'px'; return; }
    if (d.type === 'sika-cfgreq-fields') { req.fields = d.fields; save(); return; }
    if (d.type === 'sika-cfgreq-invalid') { sending(false); var s = $('[data-details]'); if (s) s.scrollIntoView({ behavior: 'smooth', block: 'start' }); say('Please check your details.'); return; }
    if (d.type === 'sika-cfgreq-sent') { sent(); return; }
  });
  function loadForm() {
    var FORM = window.cpgReqForm; if (frame || !FORM) return;
    frame = document.createElement('iframe');
    frame.title = 'Your details'; frame.setAttribute('frameborder', '0');
    frame.style.cssText = 'width:100%;height:560px;border:0;display:block;background:transparent';
    frame.src = HULK + '/corepage/customform?id=' + FORM + '&referrer_url=' + encodeURIComponent(location.href);
    $('[data-form]').appendChild(frame);
  }
  function emailText() {
    return req.lines.map(function (l, i) {
      var rows = (l.rows || []).map(function (r) { return r[0] + ': ' + r[1]; }).join(' · ');
      return (i + 1) + ') ' + l.title + ' — ' + (+l.qty || 1) + ' pcs — ' + rows + ' — ' + (l.link || '');
    }).join('\n');
  }
  function modelText() {
    var n = req.lines.length;
    return n === 1 ? req.lines[0].title : n + ' models: ' + req.lines.map(function (l) { return l.title; }).join(', ');
  }
  function postFinal() {
    if (!frame || !frameReady || !frame.contentWindow || !active()) return;
    frame.contentWindow.postMessage(JSON.stringify({ type: 'sika-cfgreq', mode: 'final', model: modelText(), materials: emailText(), link: requestLink(), qty: total(), fields: req.fields || {} }), HULK);
  }
  function sending(on) { sendBtn.disabled = on; sendBtn.textContent = on ? 'Sending…' : 'Send request'; }
  sendBtn.addEventListener('click', function () {
    if (!frame || !frameReady) { loadForm(); say('One moment, the form is loading.'); return; }
    postFinal(); sending(true);
    frame.contentWindow.postMessage(JSON.stringify({ type: 'sika-cfgreq-submit' }), HULK);
    setTimeout(function () { if (sendBtn.disabled) sending(false); }, 15000);
  });
  function sent() {
    var n = req.lines.length, pcs = total();
    req.lines = []; save();
    sending(false);
    var done = $('[data-done]');
    done.innerHTML = '<span class="cpgr__ok">' + IC.check + '</span><h3>Thank you, your request has been sent</h3><p>' + n + (n === 1 ? ' model' : ' models') + ' · ' + pcs + ' pieces. We will get back to you by email.</p>';
    done.hidden = false;
    render(); $('[data-more]').hidden = true;
    try { frame.remove(); } catch (e) {} frame = null; frameReady = false;
  }
  planBtn.addEventListener('click', function () { if (PLANNER_URL) openSetup(); });
  /* "Add another model": close the drawer and open the Choose model drawer of the page */
  $('[data-addmodel]').addEventListener('click', function () {
    closeDrawer();
    setTimeout(function () { var m = document.querySelector('[data-cpg-dd="product"] .cpg__dd-btn'); if (m) m.click(); }, 320);
  });


  /* ---------- "Add everything to floorplan": a short setup step, then the plan opens on the Floor planner page ---------- */
  var SEAT_RE = /chair|stool|armchair/i, LOUNGE_RE = /lounge|sofa|bench|daybed|day bed|sunbed|rocking/i, TABLE_RE = /table/i;
  function kindOf(l) { var p = ((window.cpgPlannerData && window.cpgPlannerData().products) || []).filter(function (x) { return x.handle === l.h; })[0] || {}, t = (p.type || '') + ' ' + l.title;
    return TABLE_RE.test(t) ? 'table' : LOUNGE_RE.test(t) ? 'lounge' : 'seat'; }
  var su = document.createElement('div'); su.className = 'cpgr-setup'; su.hidden = true; su.setAttribute('role', 'dialog'); su.setAttribute('aria-modal', 'true'); su.setAttribute('aria-labelledby', 'cpgr-su-t');
  document.body.appendChild(su);
  function opt(name, val, label, on) { return '<label class="cpgr-opt"><input type="radio" name="' + name + '" value="' + val + '"' + (on ? ' checked' : '') + '><span>' + label + '</span></label>'; }
  function openSetup() {
    var hasTable = req.lines.some(function (l) { return kindOf(l) === 'table'; }), pl = readPlan(), room = (pl && pl.room) || { w: 400, d: 300 };
    su.innerHTML = '<div class="cpgr-setup__panel"><div class="cpgr-setup__head"><h3 id="cpgr-su-t">Set up your floorplan</h3><button type="button" class="cpgr__x" data-su-close aria-label="Close">' + IC.close + '</button></div>' +
      '<div class="cpgr-setup__body">' +
      '<fieldset><legend>Room size</legend><div class="cpgr-room"><label><span>Width</span><input inputmode="numeric" data-su="w" value="' + room.w + '"></label><span class="cpgr-x">×</span><label><span>Depth</span><input inputmode="numeric" data-su="d" value="' + room.d + '"></label><span>cm</span></div></fieldset>' +
      '<fieldset><legend>How should it be set up?</legend><div class="cpgr-opts cpgr-opts--4">' +
        opt('su_lay', 'table', 'Around a table', true) + opt('su_lay', 'row', 'In a row') + opt('su_lay', 'lounge', 'Lounge group') + opt('su_lay', 'grid', 'Just place them') + '</div></fieldset>' +
      (hasTable ? '' :
      '<div data-su-tables><fieldset><legend>Tables</legend><p class="cpgr-help">There is no table in your request. Should the plan show table placeholders between the pieces, or keep the space blank?</p><div class="cpgr-opts">' +
        opt('su_ph', 'ph', 'Table placeholders', true) + opt('su_ph', 'blank', 'Blank space') + '</div></fieldset>' +
      '<fieldset><legend>Setting</legend><div class="cpgr-opts cpgr-opts--3">' + opt('su_set', 'dining', 'Dining table', true) + opt('su_set', 'cafe', 'Café tables') + opt('su_set', 'combo', 'Combination') + '</div></fieldset>' +
      '<fieldset><legend>Table shape</legend><div class="cpgr-opts">' + opt('su_shape', 'round', 'Round', true) + opt('su_shape', 'square', 'Square') + '</div></fieldset>' +
      '<p class="cpgr-help" data-su-phnote>Placeholders are only a guide in the plan and are not part of your request. You can add a real table to your request if you wish.</p></div>') +
      '<fieldset><legend>Note <span class="cpgr-opt-l">optional</span></legend><textarea data-su="note" rows="2" placeholder="For example: dining for 8 by the window">' + esc((pl && pl.note) || '') + '</textarea></fieldset>' +
      (pl && pl.items && pl.items.length ? '<p class="cpgr-help">This replaces the floorplan you have now (' + pl.items.length + ' pieces).</p>' : '') +
      '</div><div class="cpgr__foot"><button type="button" class="cpgr__btn cpgr__btn--solid" data-su-go>Create floorplan</button></div></div>';
    su.hidden = false;
    function sync() { var lay = (su.querySelector('input[name="su_lay"]:checked') || {}).value, tb = su.querySelector('[data-su-tables]'); if (tb) tb.hidden = lay !== 'table';
      var ph = (su.querySelector('input[name="su_ph"]:checked') || {}).value; var n = su.querySelector('[data-su-phnote]'); if (n) n.hidden = ph !== 'ph'; }
    su.addEventListener('change', sync); sync();
  }
  su.addEventListener('click', function (e) {
    if (e.target === su || e.target.closest('[data-su-close]')) { su.hidden = true; return; }
    if (e.target.closest('[data-su-go]')) buildPlan();
  });
  su.addEventListener('keydown', function (e) { if (e.key === 'Escape') su.hidden = true; });
  function val(n) { var r = su.querySelector('input[name="' + n + '"]:checked'); return r ? r.value : ''; }
  function face(x, y, cx, cy) { return Math.round(Math.atan2(-(cx - x), (cy - y)) * 180 / Math.PI / 15) * 15; }   // chair front (+y at 0°) turned to (cx, cy)
  function buildPlan() {
    var W = Math.max(100, Math.min(2000, parseInt(su.querySelector('[data-su="w"]').value, 10) || 400)), D = Math.max(100, Math.min(2000, parseInt(su.querySelector('[data-su="d"]').value, 10) || 300));
    var lay = val('su_lay'), useTables = lay === 'table' && !!su.querySelector('[data-su-tables]') && val('su_ph') === 'ph', set = val('su_set') || 'dining', shape = val('su_shape') || 'round';
    var units = [];
    req.lines.forEach(function (l) { for (var i = 0; i < Math.min(60, +l.qty || 1); i++) units.push({ h: l.h, title: l.title, cfg: l.cfg, kind: kindOf(l) }); });
    var seats = units.filter(function (u) { return u.kind === 'seat'; }), lounges = units.filter(function (u) { return u.kind === 'lounge'; }), tables = units.filter(function (u) { return u.kind === 'table'; });
    var out = [], ph = [];
    function put(u, x, y, r) { out.push({ u: u, x: x, y: y, r: ((r || 0) % 360 + 360) % 360 }); }
    function table(kind, w, d, x, y) { ph.push({ kind: kind, shape: shape, w: Math.round(w), d: Math.round(d), h: kind === 'cafe' ? 73 : 74, x: x, y: y }); }
    function dining(list, ox, oy) {   // one table for the whole list
      var n = list.length; if (!n) return { w: 0, h: 0 };
      if (shape === 'round') {
        var dia = Math.max(80, Math.min(200, n * 60 / Math.PI)), R = dia / 2 + 32;
        list.forEach(function (u, i) { var a = i / n * Math.PI * 2 - Math.PI / 2, x = ox + R + 30 + Math.cos(a) * R, y = oy + R + 30 + Math.sin(a) * R; put(u, x, y, face(x, y, ox + R + 30, oy + R + 30)); });
        table('dining', dia, dia, ox + R + 30, oy + R + 30); return { w: 2 * R + 60, h: 2 * R + 60 };
      }
      var side = Math.ceil(n / 2), L = Math.max(80, side * 60), T = 90, cx = ox + L / 2 + 40, cy = oy + T / 2 + 62;
      list.forEach(function (u, i) { var top = i < side, k = top ? i : i - side, cnt = top ? side : n - side, x = cx - (cnt - 1) * 30 + k * 60, y = top ? cy - T / 2 - 32 : cy + T / 2 + 32; put(u, x, y, top ? 0 : 180); });
      table('dining', L, T, cx, cy); return { w: L + 80, h: T + 124 };
    }
    function cafe(list, ox, oy, maxW) {   // tables for two, chairs facing each other across the table
      var n = Math.ceil(list.length / 2), cols = Math.max(1, Math.floor((maxW || W) / 190)), s = 60;
      for (var t = 0; t < n; t++) {
        var cx = ox + 95 + (t % cols) * 190, cy = oy + 60 + Math.floor(t / cols) * 150, a = list[t * 2], b = list[t * 2 + 1];
        if (a) put(a, cx - s / 2 - 32, cy, 270); if (b) put(b, cx + s / 2 + 32, cy, 90);
        table('cafe', s, s, cx, cy);
      }
      return { w: Math.min(n, cols) * 190, h: Math.ceil(n / cols) * 150 };
    }
    var y0 = 0, used = { w: 0, h: 0 };
    if (lay === 'table') {
      if (set === 'cafe') used = cafe(seats, 0, 0);
      else if (set === 'combo') { var half = Math.max(Math.min(seats.length, 4), Math.ceil(seats.length / 2)); var a = dining(seats.slice(0, half), 0, 0), b = cafe(seats.slice(half), a.w + 40, 0, W - a.w - 40); used = { w: a.w + 40 + b.w, h: Math.max(a.h, b.h) }; }
      else used = dining(seats, 0, 0);
      y0 = used.h + 60;
    } else if (lay === 'row') {
      var per = Math.max(1, Math.floor((W - 40) / 62));
      seats.forEach(function (u, i) { put(u, 40 + (i % per) * 62, 40 + Math.floor(i / per) * 110, 0); });
      y0 = Math.ceil(seats.length / per) * 110 + 40;
    } else if (lay === 'grid') {
      var all = seats.concat(lounges), cols = Math.max(1, Math.floor((W - 40) / 100));
      all.forEach(function (u, i) { put(u, 60 + (i % cols) * 100, 60 + Math.floor(i / cols) * 110, 0); });
      lounges = []; y0 = Math.ceil(all.length / cols) * 110 + 40;
    } else { lounges = lounges.concat(seats); }
    if (lounges.length) {   // lounge group: in a ring, facing the middle
      var n = lounges.length, R = Math.max(110, n * 40), cx = R + 60, cy = y0 + R + 60;
      lounges.forEach(function (u, i) { var ang = i / n * Math.PI * 2 + Math.PI / 2, x = cx + Math.cos(ang) * R, y = cy + Math.sin(ang) * R; put(u, x, y, face(x, y, cx, cy)); });
    }
    tables.forEach(function (u, i) { put(u, 100 + i * 160, y0 + 80, 0); });
    // fit: move the group into the middle of the room; grow the room if it does not fit
    var pts = out.map(function (o) { return [o.x, o.y]; }).concat(ph.map(function (p) { return [p.x, p.y]; }));
    if (!pts.length) return;
    var minX = Math.min.apply(null, pts.map(function (p) { return p[0]; })) - 60, maxX = Math.max.apply(null, pts.map(function (p) { return p[0]; })) + 60;
    var minY = Math.min.apply(null, pts.map(function (p) { return p[1]; })) - 60, maxY = Math.max.apply(null, pts.map(function (p) { return p[1]; })) + 60;
    W = Math.max(W, Math.ceil((maxX - minX) / 10) * 10); D = Math.max(D, Math.ceil((maxY - minY) / 10) * 10);
    var dx = W / 2 - (minX + maxX) / 2, dy = D / 2 - (minY + maxY) / 2, n0 = 0;
    function id() { return 'p' + Date.now().toString(36) + (n0++).toString(36) + Math.random().toString(36).slice(2, 5); }
    var items = out.map(function (o) { return { id: id(), key: planKey(o.u.h, o.u.cfg), h: o.u.h, title: o.u.title, cfg: o.u.cfg || null, x: Math.round(o.x + dx), y: Math.round(o.y + dy), r: o.r }; });
    if (useTables) ph.forEach(function (p) {
      var title = (p.kind === 'cafe' ? 'Café table' : p.kind === 'coffee' ? 'Coffee table' : 'Dining table') + ' placeholder';
      items.push({ id: id(), key: 'ph|' + p.kind + '|' + p.shape + '|' + p.w + 'x' + p.d, h: '', title: title, cfg: null, ph: { kind: p.kind, shape: p.shape, w: p.w, d: p.d, h: p.h }, x: Math.round(p.x + dx), y: Math.round(p.y + dy), r: 0 });
    });
    var note = (su.querySelector('[data-su="note"]') || {}).value || '';
    try { localStorage.setItem(PLAN_KEY, JSON.stringify({ t: Date.now(), room: { w: W, d: D }, items: items, note: note, from: 'request' })); } catch (e) {}
    location.href = PLANNER_URL + '#cpg-planner';
  }

  /* ---------- a shared request (?req=) opens read-only ---------- */
  (function shared() {
    var code = Q.get('req'); if (!code) return;
    try {
      var d = dec(code), prods = (window.cpgPlannerData && window.cpgPlannerData().products) || [];
      viewOnly = (d.l || []).map(function (x, i) {
        var p = prods.filter(function (q) { return q.handle === x[0]; })[0] || {};
        var cfg = x[1] || {}, f = cfg.f, frame = Array.isArray(f) ? f[0] : (f || '');
        var rows = [];
        if (cfg.m && cfg.m.length) { rows.push(['Frame', cfg.m[0]]); if (cfg.m[2]) rows.push(['Weave', cfg.m[2]]); } else if (f) rows.push(['Frame', frame]);
        if (cfg.s) rows.push(['Weave', Array.isArray(cfg.s) ? cfg.s[0] : cfg.s]);
        if (cfg.c) rows.push(['Seat cushion', cfg.c]);
        return { id: 'v' + i, h: x[0], title: p.title || x[0], cfg: cfg, qty: x[2] || 1, frame: frame, img: p.img || '', rows: rows,
          link: location.pathname + '?product=' + encodeURIComponent(x[0]) + '&cfg=' + enc(cfg) };
      });
      setTimeout(openDrawer, 600);
      dr.addEventListener('transitionend', function () {}, { once: true });
      $('[data-close]').addEventListener('click', function () { viewOnly = null; setTimeout(render, 320); });
    } catch (e) { viewOnly = null; }
  })();

  /* ---------- Choose model drawer: while a request is going, the picked model can go straight into it ---------- */
  (function modelDrawer() {
    var d = document.querySelector('x-drawer.cpg-modeldrawer'), apply = d && d.querySelector('[data-cpg-mod-apply]');
    if (!d || !apply) { if ((modelDrawer.n = (modelDrawer.n || 0) + 1) < 20) setTimeout(modelDrawer, 500); return; }
    var q = document.createElement('button'); q.type = 'button'; q.className = (apply.className || '') + ' cpgr-modadd'; q.textContent = 'Add to request'; q.hidden = true;
    apply.parentNode.insertBefore(q, apply);
    function sync() { q.hidden = !active() || !!planEdit; apply.parentNode.classList.toggle('cpgr-modfoot', !q.hidden); }
    if (window.MutationObserver) new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['open'] });
    sync();
    q.addEventListener('click', function () {
      var pick = d.querySelector('.cpg-mod__card.is-picked'), h = pick && pick.getAttribute('data-h'), c = current(); if (!h || !c) return;
      var prods = (window.cpgPlannerData && window.cpgPlannerData().products) || [], p = prods.filter(function (x) { return x.handle === h; })[0] || {};
      var line = h === c.h ? null : Object.assign({}, c, { h: h, title: p.title || h, img: p.img || '', cfg: Object.assign({}, c.cfg, { p: h }), link: (window.cpgModelLink ? location.origin + window.cpgModelLink(h) : '') });
      var l;
      if (!line) l = addCurrent(1);
      else { l = req.lines.filter(function (x) { return x.h === line.h && sameCfg(x.cfg, line.cfg); })[0]; if (l) l.qty = (+l.qty || 0) + 1; else { l = Object.assign({ id: uid(), qty: 1 }, line); req.lines.push(l); } save(); render(); }
      try { d.hide(); } catch (e) {}
      setTimeout(function () { openDrawer(); flash(l.id); }, 250);
    });
    window.__cpgrSyncModDrawer = sync;
  })();

  /* ---------- drawers of the page sit above the bar ---------- */
  (function watchDrawers() {
    function sync() { document.documentElement.classList.toggle('cpgr-drawer-open', !!document.querySelector('x-drawer[open], dialog[open]')); }
    if (window.MutationObserver) new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['open'], subtree: true });
    sync();
  })();

  render();
  [400, 1500, 4000].forEach(function (ms) { setTimeout(render, ms); });
})();
